module.exports = __webpack_public_path__ + "img/lead.9f60dc06.gif";